import React, { useEffect, useRef, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  IconButton,
  Tooltip,
  FormControl,
  MenuItem,
  Select,
  InputLabel,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import ReusableGrid from "../../components/ag grid/ReusableGrid";
import PayrollViewController from "../../redux/actions/payrollApiAction";
import ExportButton from "../../components/ag grid/ExportButton";
import "../../styles/styles.css";
import "../../styles/layout.css";

const PaySlips = () => {
  const dispatch = useDispatch();
  const gridRef = useRef(null);

  const { getPayslip, getEmployeePaySlip } = PayrollViewController();
  const { payslips } = useSelector((state) => state.payslip);
 

  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1;

  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  const [selectedRows, setSelectedRows] = useState([]);

  // Fetch payslips initially or when year/month changes if you want (currently only once)
  useEffect(() => {
    dispatch(getEmployeePaySlip());
  }, [dispatch]);

  const monthOptions = [
    { value: 1, name: "January" },
    { value: 2, name: "February" },
    { value: 3, name: "March" },
    { value: 4, name: "April" },
    { value: 5, name: "May" },
    { value: 6, name: "June" },
    { value: 7, name: "July" },
    { value: 8, name: "August" },
    { value: 9, name: "September" },
    { value: 10, name: "October" },
    { value: 11, name: "November" },
    { value: 12, name: "December" },
  ];

  const generateYears = () => {
    const years = [];
    for (let year = currentYear; year >= 2020; year--) {
      years.push(year);
    }
    return years;
  };

  // Filter payslips based on selected month and year
  const filteredPayslips = payslips?.filter((p) => {
  const payslipDate = new Date(p.month);
  const month = payslipDate.getMonth() + 1; // JS months are 0-indexed
  const year = payslipDate.getFullYear();

  return month === selectedMonth && year === selectedYear;
});


  // Columns for ag-grid including checkbox selection
  const columnDefs = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      maxWidth: 50,
      pinned: "left",
    },
    {
      headerName: "SR.No",
      valueGetter: (params) => params.node.rowIndex + 1,
      maxWidth: 80,
    },
    {
      headerName: "Employee Id",
      field: "employee_id",
      flex: 0.7,
    },
    {
      headerName: "Employee",
      field: "employee_name",
      flex: 1,
    },
    {
      headerName: "Month",
      field: "month",
      flex: 0.7,
      valueFormatter: (params) =>
        monthOptions.find((m) => m.value === parseInt(params.value))?.name || params.value,
    },
    
    {
      headerName: "Net Salary",
      field: "salary.net_salary",
      flex: 1,
    },
    {
      headerName: "Generated At ",
      field: "generated_at",
      flex: 1,
      valueFormatter: (params) =>
        params.value ? new Date(params.value).toLocaleDateString() : "",
    },
    {
      headerName: "Actions",
      field: "actions",
      pinned: "right",
      maxWidth: 100,
      cellRenderer: (params) => {
        const fullDate = new Date(params.data.month);
        const month = fullDate.getMonth() + 1;
        const year = fullDate.getFullYear();
       

        return (
          <Tooltip title="Download Payslip">
            <IconButton
              color="primary"
              size="small"
              onClick={() =>
                dispatch(
                  getPayslip(
                    params.data.employee, // correct field
                    month,
                    year,
                    params.data.employee_id   
                  )
                )
              }
            >
              <DownloadIcon />
            </IconButton>
          </Tooltip>
        );
      }

    },
  ];

  // Selection changed handler for the grid
  // const onSelectionChanged = (event) => {
  //   const selectedNodes = event.api.getSelectedNodes();
  //   const selectedData = selectedNodes.map((node) => node.data);
  //   setSelectedRows(selectedData);
  // };

  return (
    <div>
      {/* Export Button Above Title */}
      <div className="d-flex justify-content-between mb-2">
        {selectedRows.length > 0 ? (
          <ExportButton
            gridRef={gridRef}
            selectedRows={selectedRows}
            fileName={`Payslips_${selectedMonth}_${selectedYear}.csv`}
            exportColumns={[
              "employee_name",
              "month",
              "year",
              "net_salary",
              "generated_on",
            ]}
          />
        ) : (
          <div /> // empty div to maintain spacing
        )}
      </div>

      {/* Filters + Title */}
      <div className="label-card">
        <Row className="justify-content-between w-100">
          <Col>
            <h3>Payslips List</h3>
          </Col>
          <Col className="d-flex justify-content-end gap-3">
            <FormControl size="small" style={{ minWidth: 100 }}>
              <InputLabel>Month</InputLabel>
              <Select
            value={selectedMonth}
            label="Month"
            onChange={(e) => setSelectedMonth(parseInt(e.target.value))}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 3 * 48, // 4 items * item height (48px default)
                  overflowY: 'auto',
                },
              },
            }}
          >
            {monthOptions.map((month) => (
              <MenuItem key={month.value} value={month.value}>
                {month.name}
              </MenuItem>
            ))}
          </Select>

            </FormControl>

            <FormControl size="small" style={{ minWidth: 100 }}>
              <InputLabel>Year</InputLabel>
              <Select
              value={selectedYear}
              label="Year"
              onChange={(e) => setSelectedYear(parseInt(e.target.value))}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 3 * 48,
                    overflowY: 'auto',
                  },
                },
              }}
            >
              {generateYears().map((year) => (
                <MenuItem key={year} value={year}>
                  {year}
                </MenuItem>
              ))}
            </Select>

            </FormControl>
          </Col>
        </Row>
      </div>

      {/* Grid */}
      <div className="ag-theme-material" style={{ height: "70vh" }}>
        <ReusableGrid
          rowData={filteredPayslips}
          columnDefs={columnDefs}
          gridRef={gridRef}
          pagination={true}
          onSelectionChanged={(rows) => setSelectedRows(rows)}
        />
      </div>
    </div>
  );
};

export default PaySlips;
